import { useContent } from '../data/ContentContext';
import { FeatureIcon } from '../components/icons';
import './featurePage.css';
import './SqmExpertPage.css';

export function SqmExpertPage() {
  const { sqmExpertContent } = useContent();
  const { hero } = sqmExpertContent;

  return (
    <div className="page">
      {/* Hero banner */}
      <header
        className="se-hero"
        style={{ backgroundImage: 'url(/sqm-expert/expert.png)' }}
      >
        <div className="se-hero__overlay">
          <span className="se-hero__eyebrow">
            <FeatureIcon name="chat" size={18} /> {hero.subtitle}
          </span>
          <h1 className="se-hero__title">{hero.title}</h1>
          <p className="se-hero__desc">{hero.description}</p>
        </div>
      </header>

      {/* DAP-AI SQM AI Training Pool Matrix */}
      <section className="feat-card se-wide">
        <h2 className="feat-card__title">
          <FeatureIcon name="grid" /> DAP-AI SQM AI Training Pool Matrix
        </h2>
        <p className="se-summary">
          This is a real-time update for status for our whole SQM knowledge
          base.
        </p>
        <div className="se-entrance__media">
          <img
            src="/sqm-expert/training-pool-matrix.png"
            alt="DAP-AI SQM AI Training Pool Matrix"
            className="se-entrance__img"
          />
        </div>
      </section>

      {/* SQM Expert Entrance */}
      <section className="feat-card se-wide">
        <h2 className="feat-card__title">
          <FeatureIcon name="chat" /> SQM Expert Entrance
        </h2>
        <p className="se-entrance__subtitle">SQM Expert QuickSuite Ver</p>
        <div className="se-entrance__media">
          <img
            src="/sqm-expert/quicksuite.png"
            alt="SQM Expert QuickSuite"
            className="se-entrance__img"
          />
        </div>
        <a
          className="se-entrance__btn"
          href={sqmExpertContent.launchUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FeatureIcon name="link" size={18} /> Quick Link
        </a>
      </section>
    </div>
  );
}
